import { createSlice, current, Draft, PayloadAction } from "@reduxjs/toolkit";
interface InitialState {
  userNotifications: any;
  userNotificationsAll: any;
}

const initialState: any = {
  userNotifications: {},
  userNotificationsAll: {},
};
const userNotificationSlice = createSlice({
  name: "userNotificationSlice",
  initialState,
  reducers: {
    listUserNotifications: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => {
      const previousState = current(state);
      if (Object.keys(previousState.userNotifications).length > 0) {
        let data = [
          ...previousState.userNotifications.notifications,
          ...action.payload.notifications,
        ];
        let newData = data.filter(
          (tag: any, index: any, array: any) =>
            array.findIndex((t: any) => t.pk == tag.pk && t.sk == tag.sk) ==
            index
        );
        state.userNotifications = {
          ...state.userNotifications,
          notifications: newData,
          LastEvaluatedPk: action.payload.LastEvaluatedPk,
          LastEvaluatedSk: action.payload.LastEvaluatedSk,
          unread: action?.payload?.unread,
          read: action?.payload?.read,
        };
      } else {
        state.userNotifications = action.payload;
      }
    },
    listUserNotificationsAll: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => {
      const previousState = current(state);
      if (Object.keys(previousState.userNotificationsAll).length > 0) {
        const notificationAPIRes = action.payload?.notificationAPIRes;
        const type = action.payload?.type;
        if (type === "unread") {
          const data = [
            ...previousState?.userNotificationsAll?.notificationsUnRead
              ?.notifications,
            ...notificationAPIRes?.notificationsUnRead?.notifications,
          ];
          let newData = data.filter(
            (tag: any, index: any, array: any) =>
              array.findIndex((t: any) => t.pk == tag.pk && t.sk == tag.sk) ==
              index
          );

          const notificationsUnRead = {
            ...notificationAPIRes?.notificationsUnRead,
            LastEvaluatedPk:
              notificationAPIRes?.notificationsUnRead?.LastEvaluatedPk,
            LastEvaluatedSk:
              notificationAPIRes?.notificationsUnRead?.LastEvaluatedSk,
            notifications: newData,
          };

          state.userNotificationsAll = {
            ...state.userNotificationsAll,
            count: notificationAPIRes?.count,
            read: notificationAPIRes?.read,
            unread: notificationAPIRes?.unread,
            notificationsUnRead: notificationAPIRes?.count !== 0 ? notificationsUnRead : {
              LastEvaluatedPk:"",
              LastEvaluatedSk:"",
              notifications: [],
            },
          };
        } else if (type === "read") {
          const data = [
            ...previousState?.userNotificationsAll?.notificationsRead
              ?.notifications,
            ...notificationAPIRes?.notificationsRead?.notifications,
          ];
          let newData = data.filter(
            (tag: any, index: any, array: any) =>
              array.findIndex((t: any) => t.pk == tag.pk && t.sk == tag.sk) ==
              index
          );

          const notificationsRead = {
            ...notificationAPIRes.notificationsRead,
            LastEvaluatedPk:
              notificationAPIRes?.notificationsRead?.LastEvaluatedPk,
            LastEvaluatedSk:
              notificationAPIRes?.notificationsRead?.LastEvaluatedSk,
            notifications: newData,
          };

          state.userNotificationsAll = {
            ...state.userNotificationsAll,
            count: notificationAPIRes?.count,
            read: notificationAPIRes?.read,
            unread: notificationAPIRes?.unread,
            notificationsRead: notificationAPIRes?.read !== 0 ? notificationsRead : {
              LastEvaluatedPk:"",
              LastEvaluatedSk:"",
              notifications: [],
            },
          };
        } else if (type === "all") {
          const data = [
            ...previousState?.userNotificationsAll?.notificationsAll
              ?.notifications,
            ...notificationAPIRes?.notificationsAll?.notifications,
          ];
          let newData = data.filter(
            (tag: any, index: any, array: any) =>
              array.findIndex((t: any) => t.pk == tag.pk && t.sk == tag.sk) ==
              index
          );

          const notificationsAll = {
            ...notificationAPIRes.notificationsAll,
            LastEvaluatedPk:
              notificationAPIRes?.notificationsAll?.LastEvaluatedPk,
            LastEvaluatedSk:
              notificationAPIRes?.notificationsAll?.LastEvaluatedSk,
            notifications: newData,
          };

          state.userNotificationsAll = {
            ...state.userNotificationsAll,
            count: notificationAPIRes?.count,
            read: notificationAPIRes?.read,
            unread: notificationAPIRes?.unread,
            notificationsAll: notificationAPIRes?.count !== 0 ? notificationsAll : {
              LastEvaluatedPk:"",
              LastEvaluatedSk:"",
              notifications: [],
            },
          };
        } else if (type === "") { //this is the case when interval api is called for display new unread notifications

          //Unread
          const URdata = [
            ...notificationAPIRes?.notificationsUnRead?.notifications,
            ...previousState?.userNotificationsAll?.notificationsUnRead
              ?.notifications,
          ];
          let URnewData = URdata.filter(
            (tag: any, index: any, array: any) =>
              array.findIndex((t: any) => t.pk == tag.pk && t.sk == tag.sk) ==
              index
          );
          const notificationsUnRead = {
            ...previousState?.userNotificationsAll?.notificationsUnRead,
            notifications: URnewData,
          };

          //Read
          const Rdata = [
            ...notificationAPIRes?.notificationsRead?.notifications,
            ...previousState?.userNotificationsAll?.notificationsRead
              ?.notifications,
          ];
          let RnewData = Rdata.filter(
            (tag: any, index: any, array: any) =>
              array.findIndex((t: any) => t.pk == tag.pk && t.sk == tag.sk) ==
              index
          );
          const notificationsRead = {
            ...previousState?.userNotificationsAll?.notificationsRead,
            notifications: RnewData,
          };

          //All
          const Alldata = [
            ...notificationAPIRes?.notificationsAll?.notifications,
            ...previousState?.userNotificationsAll?.notificationsAll
              ?.notifications,
          ];
          let AllnewData = Alldata.filter(
            (tag: any, index: any, array: any) =>
              array.findIndex((t: any) => t.pk == tag.pk && t.sk == tag.sk) ==
              index
          );
          const notificationsAll = {
            ...previousState?.userNotificationsAll?.notificationsAll,
            notifications: AllnewData,
          };

          state.userNotificationsAll = {
            ...state.userNotificationsAll,
            count: notificationAPIRes?.count,
            read: notificationAPIRes?.read,
            unread: notificationAPIRes?.unread,
            notificationsUnRead: notificationAPIRes?.count !== 0 ? notificationsUnRead : {
              LastEvaluatedPk:"",
              LastEvaluatedSk:"",
              notifications: [],
            },
            notificationsAll: notificationAPIRes?.count !== 0 ? notificationsAll : {
              LastEvaluatedPk:"",
              LastEvaluatedSk:"",
              notifications: [],
            },
            notificationsRead: notificationAPIRes?.count !== 0 ? notificationsRead : {
              LastEvaluatedPk:"",
              LastEvaluatedSk:"",
              notifications: [],
            },
          };
        }
      } else {
        state.userNotificationsAll = action.payload?.notificationAPIRes;
      }
    },
    updateUserNotificationList: (state: any, { payload }) => {
      state.userNotificationsAll = {
        ...state.userNotificationsAll,
        notificationsAll: payload?.notificationsAll,
        notificationsRead: payload?.notificationsRead,
        notificationsUnRead: payload?.notificationsUnRead,
        count: payload?.count,
        unread: payload?.unread,
        read: payload?.read,
      };
    },
  },
});

export default userNotificationSlice.reducer;
export const {
  listUserNotifications,
  listUserNotificationsAll,
  updateUserNotificationList,
} = userNotificationSlice.actions;
